var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"home-page-main"},[_c('SlideBanner',{attrs:{"type":"BANNER_HOME_SLIDE"}}),_vm._v(" "),_c('BannerItem',{attrs:{"type":"BANNER_HOME_UI_NEW"}}),_vm._v(" "),_c('Questioning'),_vm._v(" "),_c('OnlineClass'),_vm._v(" "),_c('LibSupplies'),_vm._v(" "),_c('Teachers'),_vm._v(" "),_c('Comments'),_vm._v(" "),_c('News')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }